import {
    ACCESS_LINK_REQUEST_ERROR,
    ACCESS_LINK_REQUEST_SENT,
    AUTHORIZING_PERMISSIONS_REQUEST_ERROR,
    AUTHORIZING_PERMISSIONS_REQUEST_SENT,
    AUTHORIZING_PERMISSIONS_REQUEST_SUCCESS,
    CLEAR_PERMISSIONS,
    LOGOUT,
    PERMISSION_APPROVE_REQUEST_ERROR,
    PERMISSION_APPROVE_REQUEST_SUCCESS,
    PERMISSION_DENY_REQUEST_ERROR,
    PERMISSION_DENY_REQUEST_SUCCESS,
    REQUEST_ERROR,
    REQUEST_SENT,
    REQUEST_SUCCESS,
    SHARE_DATA_ERROR,
    SHARE_DATA_SUCCESS
} from "../actions/actions";
import {requestStatus} from './requests_reducers';

const initialState = {
    entries: [],
    shareDataSuccess: null,
    shareDataError: null,
    permissionOperationError: null,
    request: requestStatus(undefined, {}),
    linkRequest: requestStatus(undefined, {})
}

/**
 * Permission reducer. Reduce state based on action type.
 *
 * @param {object} state the state of permissions
 * @param {action} action the action to execute on the state
 * @returns the new state
 */
export function permissions(state = initialState, action) {
    switch (action.type) {
        case AUTHORIZING_PERMISSIONS_REQUEST_SENT: {
            // eslint-disable-next-line no-unused-vars
            const {shareDataError, shareDataSuccess, permissionOperationError, ...rest} = state;
            return {...rest, request: requestStatus(rest.request, {type: REQUEST_SENT})}
        }
        case AUTHORIZING_PERMISSIONS_REQUEST_SUCCESS: {
            return {...state, entries: action.result, request: requestStatus(state.request, {type: REQUEST_SUCCESS})}
        }
        case AUTHORIZING_PERMISSIONS_REQUEST_ERROR: {
            // eslint-disable-next-line no-unused-vars
            const {entries, ...rest} = state;
            return {...rest, request: requestStatus(rest.request, {type: REQUEST_ERROR, response: action.result})}
        }
        case ACCESS_LINK_REQUEST_SENT: {
            return {...state, linkRequest: requestStatus(state.linkRequest, {type: REQUEST_SENT})}
        }
        case ACCESS_LINK_REQUEST_ERROR: {
            return {
                ...state,
                linkRequest: requestStatus(state.linkRequest, {type: REQUEST_ERROR, response: action.result})
            }
        }
        case PERMISSION_DENY_REQUEST_SUCCESS:
        case PERMISSION_APPROVE_REQUEST_SUCCESS: {
            return {...state, permissionOperationError: initialState.permissionOperationError}
        }
        case PERMISSION_DENY_REQUEST_ERROR:
        case PERMISSION_APPROVE_REQUEST_ERROR: {
            return {...state, permissionOperationError: action.result}
        }
        case SHARE_DATA_SUCCESS: {
            return {...state, shareDataSuccess: true, shareDataError: initialState.shareDataError}
        }
        case SHARE_DATA_ERROR: {
            return {...state, shareDataError: action.result, shareDataSuccess: initialState.shareDataSuccess}
        }
        case CLEAR_PERMISSIONS:
        case LOGOUT: {
            return {...state, ...initialState};
        }
        default: {
            return state;
        }
    }
}